export default __webpack_public_path__ + "static/media/med.e4698e54.mp3";